import React from 'react';
import { Form, Select, Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

/**
 * Select + دکمه مدیریت (پلاس) — Form.Item درست برای اعتبارسنجی Ant Design
 */
const WorkSelectWithManage = ({
  label,
  name,
  rules,
  children,
  selectProps = {},
  onManageClick,
  onManage,
  manageLoading = false,
  manageTooltip = 'مدیریت',
  required,
}) => {
  const handleManage = onManageClick ?? onManage;
  return (
  <Form.Item
    label={label ? <span style={{ fontFamily: 'CustomFont' }}>{label}</span> : null}
    required={required}
    style={{ fontFamily: 'CustomFont' }}
  >
    <div className="flex gap-2 items-center w-full">
      <Form.Item name={name} rules={rules} noStyle className="flex-1 mb-0 min-w-0">
        <Select
          style={{ width: '100%', fontFamily: 'CustomFont' }}
          optionFilterProp="label"
          {...selectProps}
        >
          {children}
        </Select>
      </Form.Item>
      <Tooltip title={manageTooltip}>
        <Button
          icon={<PlusOutlined />}
          onClick={handleManage}
          loading={manageLoading}
          className="flex-shrink-0"
          style={{ fontFamily: 'CustomFont' }}
        />
      </Tooltip>
    </div>
  </Form.Item>
  );
};

export default WorkSelectWithManage;
